import { Injectable } from '@angular/core'
import { environment } from '../../../../environments/environment'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { ResponseRequestModel } from '../../models/response.model'
import { AtribuirBody, NoShowBody, SearchMonitoramentoModel } from '../../models/monitoring-os.model'

// Torre de Monitoramento — tela id 73. Substituiu AgendaFrota/search-paginated/monitoramento;
// a rota antiga continua no ar mas nada mais aqui chama ela.
@Injectable({
  providedIn: 'root',
})
export class MonitoringService {
  private baseUrl = environment.baseUrl
  private resource = 'Monitoramento'

  constructor(private httpClient: HttpClient) {}

  // Uma chamada só devolve os cards do topo (resumo), a página de serviços (itens) e
  // o relógio do servidor (servidorAgora). Sem dataInicio o período é hoje; mais de
  // 31 dias devolve 400 com mensagem pronta pra exibir. 206 quando não há serviço no período.
  public searchPaginated(
    page: number,
    rows = 15,
    model: SearchMonitoramentoModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/search-paginated?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }

  // Aceita fase 1 a 5 (desde a leva 5, que inseriu "Motorista notificado" como
  // fase 1). Confirmar a fase 1 por aqui equivale a confirmarEnvio() — são duas
  // rotas pro mesmo efeito, use a que der menos trabalho. Corpo opcional:
  // dataOcorrido/horaOcorrido vazios = agora; preencher quando o operador estiver
  // lançando algo que já aconteceu. Quem confirmou sai do token, nunca do corpo.
  // Confirmar uma fase adiantada grava também as etapas do meio — a tela só
  // recarrega a linha. Finalizar o serviço é confirmar a fase 5.
  public confirmarFase(
    osId: string,
    fase: number,
    body: { dataOcorrido?: string; horaOcorrido?: string; observacao?: string } = {},
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/${osId}/fases/${fase}/confirmar`,
      body,
    )
  }

  // Marca no-show. 409 se a OS já está marcada — avisar, não repetir (o back
  // recusa empilhar). Data/hora são do fato, não do clique: o operador quase
  // sempre registra depois de tentar contato e esperar.
  public marcarNoShow(osId: string, body: NoShowBody = {}): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/${osId}/no-show`,
      body,
    )
  }

  // Desfaz. Existe porque um clique errado no POST apagava o prazo da linha
  // inteira (no-show ganha de todas as cores do farol) e só saía pela tela de
  // ocorrências da OS antes deste endpoint existir.
  public desmarcarNoShow(osId: string): Observable<ResponseRequestModel> {
    return this.httpClient.delete<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/${osId}/no-show`,
    )
  }

  // Sem corpo — o operador só está registrando que mandou a OS pro motorista (o
  // sistema não dispara WhatsApp). Clicar de novo atualiza o carimbo (reenvio é
  // reenvio); resolve a fase 1 cobrar confirmação de quem nunca recebeu nada.
  public confirmarEnvio(osId: string): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/${osId}/confirmar-envio`,
      {},
    )
  }

  // Desfaz — a fase 1 volta a apontar pendenciaDe: 'torre'.
  public desfazerEnvio(osId: string): Observable<ResponseRequestModel> {
    return this.httpClient.delete<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/${osId}/confirmar-envio`,
    )
  }

  // O back monta a mensagem, não envia. mensagem pro botão copiar, linkWhatsApp pro
  // botão abrir — linkWhatsApp vem vazio quando o motorista não tem telefone.
  public getMensagemMotorista(osId: string): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/${osId}/mensagem-motorista`,
    )
  }

  // Aloca motorista e/ou veículo numa chamada só — o back decide create/edit pelo
  // agendaId enviado, e confirma a OS sozinho se ela estava em 12 (Aguardando
  // Confirmação Operador). Resposta é a linha inteira já atualizada.
  public atribuir(osId: string, body: AtribuirBody): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/${osId}/atribuir`,
      body,
    )
  }

  // Só vale pra OS em 12 (Aguardando Confirmação Operador) — 400 fora disso. Vai
  // pra 5 Agendado e fecha a compra.
  public confirmarAtribuicao(osId: string): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/${osId}/confirmar-atribuicao`,
      {},
    )
  }

  // Vai pra 13 Em Reajuste. motivo é obrigatório — é o que o fornecedor lê no portal.
  public recusarAtribuicao(osId: string, motivo: string): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/${osId}/recusar-atribuicao`,
      { motivo },
    )
  }
}
